import axios from '../axiosInstances/axiosInstance';

export const sendReferrals = (emails, note) => {
  return axios.post(`/users/referrals/invite`, {
    emails: emails,
  });
};
